<ng-container *ngIf="data.extra['id'] === 'USERONLINE' && userData">
	<submenu-user [internalPage]="internalPage" [isSticky]="isSticky"></submenu-user>
</ng-container>
<ng-container *ngIf="data.extra['id'] === 'NOTIFICATIONS' && userData">
	<submenu-notification [internalPage]="internalPage" [isSticky]="isSticky"></submenu-notification>
</ng-container>
